import * as React from "react";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../../Shared/Process/Process/ProcessComponent";
import { IAC } from "../../../../Common/AdviserCharges/Components/IAC";
import { OAC } from "../../../../Common/AdviserCharges/Components/OAC";
import { RIAC } from "../../../../Common/AdviserCharges/Components/RIAC";
import { AdviserChargesContents } from "../../../../Common/AdviserCharges/Resource/Contents";
import { ChargesOnIllustration } from "../../../../Common/AdviserCharges/Components/ChargesOnIlustration";

interface IAdviserChargesProps extends IProcessComponentProps {}

interface IAdviserChargesState {}

export class AdviserCharges extends ProcessComponent<IAdviserChargesProps, IAdviserChargesState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    private getProps = (key) => {
        const { onChange, data, showErrorMsgPopUp } = this.props;
        return {
            data: data[key],
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: (msg, isShow) => showErrorMsgPopUp(msg, isShow),
            onChange: (changes) => this.onDataChange(onChange, changes, data, key),
            valueLimit: 99.99,
        };
    };

    public render(): JSX.Element {
        return (
            <>
                <h2 className="mb-22">Adviser charges</h2>

                <h3 className="heading-underlined">{AdviserChargesContents.ProductLevel}</h3>

                <IAC type={SubAccountType.JuniorSipp} {...this.getProps("PensionApply")} />

                <RIAC type={SubAccountType.JuniorSipp} {...this.getProps("PensionApply")} />

                <OAC type={SubAccountType.JuniorSipp} {...this.getProps("PensionApply")} />

                <ChargesOnIllustration {...this.getProps("PensionApply")} />
            </>
        );
    }
}
